import { useEffect } from "react";

/**
 * Adds `<meta name="robots" content="noindex,follow">` to the document head
 * when a SPA detail page renders a "not found" state. Removes it on unmount.
 *
 * WHY: Our SPA returns HTTP 200 for every URL (the index.html). When a job/
 * admit-card/result/blog slug doesn't exist in DB, the React component shows
 * a "Not found" message but the HTTP status stays 200 — which Google flags
 * as a "soft 404" and uses to demote site quality.
 *
 * Solution: dynamically inject `noindex` ONLY when item == false (404 from API).
 * Google will then remove the URL from its index cleanly.
 */
export default function useNoindexOnNotFound(notFound) {
  useEffect(() => {
    if (!notFound) return;
    const robotsMeta = document.querySelector('meta[name="robots"]');
    const oldContent = robotsMeta ? robotsMeta.content : null;
    if (robotsMeta) {
      robotsMeta.content = "noindex,follow";
    } else {
      const m = document.createElement("meta");
      m.name = "robots";
      m.content = "noindex,follow";
      m.id = "robots-noindex-tmp";
      document.head.appendChild(m);
    }
    return () => {
      if (robotsMeta && oldContent !== null) {
        robotsMeta.content = oldContent;
      } else {
        const tmp = document.getElementById("robots-noindex-tmp");
        if (tmp) tmp.remove();
      }
    };
  }, [notFound]);
}
